import { render } from "./ClientSpaceSuccessId.vue?vue&type=template&id=1e8faae7&scoped=true"
import script from "./ClientSpaceSuccessId.vue?vue&type=script&lang=js"
export * from "./ClientSpaceSuccessId.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=1e8faae7&lang=scss&scoped=true"
import "./custom-clientSpaceSuccess.scss?vue&type=style&index=1&id=1e8faae7&lang=scss&scoped=true"
import "./ClientSpaceSuccessId.vue?vue&type=style&index=2&id=1e8faae7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8faae7"]])

export default __exports__